import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { supportedContracts } from '../constants';
export var LessThan = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'lessThan',
    description: 'Check if a amount2 is less than amount1',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                amount1: new FctValue({ destination: 'wei_amount' }),
                decimals1: new FctDecimals({}),
                amount2: new FctValue({ destination: 'wei_amount' }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amount2 - amount1',
                innerIndex: 0,
            }),
        },
    }); },
});
